import { createContext, type ReactNode, useContext, useState } from 'react';
import { usePhieuKeToanTheoNghiepVuExport, useSearchFieldStates } from './hooks';

interface PhieuKeToanTheoNghiepVuContextValue {
  exportToExcel: () => Promise<void>;
  canExport: boolean;
  isExporting: boolean;
  isImportDialogOpen: boolean;
  openImportDialog: () => void;
  closeImportDialog: () => void;
  searchFieldStates: ReturnType<typeof useSearchFieldStates>;
  isLoadingImport: boolean;
  setIsLoadingImport: (isLoading: boolean) => void;
}

const PhieuKeToanTheoNghiepVuContext = createContext<PhieuKeToanTheoNghiepVuContextValue | null>(null);

export const usePhieuKeToanTheoNghiepVuContext = () => {
  const context = useContext(PhieuKeToanTheoNghiepVuContext);
  if (!context) {
    throw new Error('usePhieuKeToanTheoNghiepVuContext must be used within PhieuKeToanTheoNghiepVuProvider');
  }
  return context;
};

export const PhieuKeToanTheoNghiepVuProvider = ({ children }: { children: ReactNode }) => {
  const { exportToExcel, canExport, isExporting } = usePhieuKeToanTheoNghiepVuExport();
  const searchFieldStates = useSearchFieldStates();
  const [isImportDialogOpen, setIsImportDialogOpen] = useState(false);
  const [isLoadingImport, setIsLoadingImport] = useState(false);

  const openImportDialog = () => setIsImportDialogOpen(true);
  const closeImportDialog = () => setIsImportDialogOpen(false);

  return (
    <PhieuKeToanTheoNghiepVuContext.Provider
      value={{
        exportToExcel,
        canExport,
        isExporting,
        isLoadingImport,
        setIsLoadingImport,
        isImportDialogOpen,
        openImportDialog,
        closeImportDialog,
        searchFieldStates
      }}
    >
      {children}
    </PhieuKeToanTheoNghiepVuContext.Provider>
  );
};
